import { GridColDef } from "@mui/x-data-grid-pro";
import { useHostTrendingCustomerScores } from "services/api/SWRService";
import { IHostTrendingCustomerScore } from "services/models/Host";
import { PlayerNameCell } from "./PlayerNameCell";
import { numberCol, tierCol } from "utils/datagrid-utils";
import { GridPaginationProps } from "./helpers";
import { SWRDataGrid } from "./SWRDataGrid";
import { useMobile } from "hooks/Mobile/useMobile";
import { filterPanelSx } from ".";
import { PLAYER_NAME_MIN_WIDTH } from "constants/tables";

const columns: GridColDef<IHostTrendingCustomerScore>[] = [
  {
    field: "currentTier",
    headerName: "Tier",
    ...tierCol,
  },
  {
    field: "fullName",
    headerName: "Player",
    flex: 1,
    minWidth: PLAYER_NAME_MIN_WIDTH,
    renderCell: ({ row }) => <PlayerNameCell {...row} />,
  },
  {
    field: "currentCustomerValueScore",
    headerName: "Current CVS",
    minWidth: 140,
    ...numberCol(),
  },
  {
    field: "average30DayCustomerValueScore",
    headerName: "AVG 30-Day Score",
    minWidth: 140,
    ...numberCol(),
  },
  {
    field: "average90DayCustomerValueScore",
    headerName: "AVG 90-Day Score",
    minWidth: 140,
    ...numberCol(),
  },
];
export const TrendingCustomerScoresTable = (props: GridPaginationProps): JSX.Element => {
  const response = useHostTrendingCustomerScores();
  const isMobile = useMobile();

  return (
    <SWRDataGrid
      initialState={{
        columns: {
          columnVisibilityModel: {
            currentTier: false,
          },
        },
      }}
      name="trending-customer-value-score"
      response={response}
      columns={columns}
      slotProps={{
        filterPanel: isMobile ? filterPanelSx : undefined,
      }}
      noRowsMessage="No Trending Customer Values Found"
      {...props}
    />
  );
};
